export const ExcludedNodeIdsList = ['pci', 'pci-logs-data-platform'];
